'use strict';

module.exports = ['$http',
	function ($http) {

		return {
			restrict: 'E',
			scope: {
				form: '=',
				name: '=',
				title: '=',
				model: '=',
                pbreadonly: '=',
				options: '=',
                details: '=',
			},
			templateUrl: '/partial/app.directives.twitter_tag',
			link: function (scope, element, attributes) {
				if(!scope.model) {
					scope.model = [];
				}
				// scope.showMore = false;
				scope.tweets = [];
				scope.customModel = {
					name: 'Twitter',
					options: {
						icon: 'twitter',
						foreground: '#fff',
						color: '#50acee'
					}
				};

				function error(error, value = null) {
					if (scope.form && scope.form[scope.name]) { //make sure there is an form
						if (value == null) {
							return scope.form[scope.name].$error[error];
						} else {
							scope.form[scope.name].$setValidity(error, value);
						}
					}
				}

				scope.getTweets = () => {
					scope.loading = true;
					let tags = scope.model;
					if (!tags) {
						scope.headerData = {};
						scope.tweets = {};
						scope.loading = false;

						if (error('noUsername')) {
							error('noUsername', true);
						}
						if(error('noAccounts')) {
							error('noAccounts', true);
						}
					} else {
						$http.post('/social/twitter/tagdata/', {'tags': tags}).then((response) => {
							if (response.data.status == 404) {
								scope.headerData = {};
								scope.tweets = {};
							} else if (response.data.status == 400 && response.data.message == 'no_accounts') {
								error('noAccounts', false);
							} else if (response.data.status == 200) {
								scope.headerData = response.data.headerData;
								scope.tweets = response.data.tweets;

								if(error('noAccounts')) {
									error('noAccounts', true);
								}
							}
							scope.loading = false;
						});
					}
				};

				scope.toggleMore = () => {
					scope.showMore = !scope.showMore;
				};

				scope.$watch('model', (newVal) => {
					if(newVal !== undefined) {
						scope.getTweets();
					}
				}, true);

				//init field when loaded
				scope.getTweets();
			}
		};
	}
];

